import { Badge } from "./Badge";
import type { Finding } from "../api/reports";

const severityToVariant: Record<Finding["severity"], "ok" | "warn" | "danger" | "neutral"> = {
  breach: "danger",
  trend: "warn",
  watch: "neutral",
  positive: "ok",
};

export function FindingCard({ finding }: { finding: Finding }) {
  return (
    <div className="rounded-[11px] border border-border-default p-4 flex flex-col gap-1.5">
      <div className="flex items-start gap-3">
        <Badge variant={severityToVariant[finding.severity]}>
          {finding.severity}
        </Badge>
        <div className="flex-1 min-w-0">
          <div className="text-[13.5px] font-semibold text-text-primary">
            {finding.title}
          </div>
          <div className="text-[13px] text-text-secondary mt-0.5">
            {finding.body}
          </div>
          {finding.source && (
            <div className="mt-1 text-[11.5px] font-semibold text-accent-text">
              {finding.source}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
